import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { ClaimModel } from '../models/claimModel';
import { environment } from 'src/environments/environment';
import { RestAPIService } from 'src/app/services/restapi.service';
import { AddEditClaimsComponent } from 'src/app/components/security/claims/widgets/manageClaims/addeditclaim.component';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-claims',
    templateUrl: './claim.component.html'
})
export class ClaimComponent implements OnInit {
    public pageSize = 10;
    public currentPage = 0;
    public totalSize = 0;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    claimList: ClaimModel[] = [];
    currentSort!: Sort;
    claimModel: ClaimModel = new ClaimModel();
    displayedColumns = ['code', 'description', 'action'];
    dataSource = new MatTableDataSource<ClaimModel>();
    isAdvanceSearchFilter: boolean = false;
    filterKey: string = '';
    sortedClaimList: ClaimModel[] = [];

    constructor(public _restAPI: RestAPIService,
        public dialog: MatDialog) {
            this._restAPI.loading  = false;
        }
  
    ngOnInit() {
        if (localStorage["applyClaimFilterValue"] === 'true') {
            this.getClaimList(localStorage["claimFilterValue"]);
        }
        else {
            this.getClaimList('');
        }
        localStorage["applyClaimFilterValue"] = '';
    }

    onDisplayFilter(e : any) {
        this.isAdvanceSearchFilter = !this.isAdvanceSearchFilter;
        if(e) {
            e.stopPropagation();
        }
    }

    applyFilter(filterValue: string) {
        if (this.dataSource?.paginator) {
            this.dataSource.paginator.pageIndex = 0;
        }
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        localStorage["claimFilterValue"] = filterValue;
        this.dataSource.filter = filterValue;
    }
    
    async getClaimList(filterValue : any) {
        this._restAPI.loading  = true;
        this._restAPI.get<ClaimModel[]>(environment.apiURL + 'api/claim/list').subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.claimList = data;
                this.sortedClaimList = this.claimList.slice();
                this.totalSize = this.sortedClaimList.length;
                this.dataSource.data = data;
                this.dataSource.filter = filterValue;
                this.filterKey = filterValue;
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;
            },
            error: (error) => {this._restAPI.loading  = false;console.error(error)}
        });
    }

    openClaimDialog(roleModel: ClaimModel): void {
        const dialogRef = this.dialog.open(AddEditClaimsComponent, {
            width:"700px",
            data: roleModel
        });

        dialogRef.afterClosed().subscribe(result => {
            this.claimModel = new ClaimModel();
            if (result) {
                this.getClaimList(localStorage["claimFilterValue"]);
            }
            localStorage["applyClaimFilterValue"] = '';
        });
    }
}